import { ChevronDown, Tag } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { ServiceIcon } from "@/components/site/ServiceIcon";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import { AVAIL_LABEL } from "@/lib/api";

const PromoBanner = ({ s }) =>
  s.promo_active && s.promo_title ? (
    <div className="mb-5 flex items-start gap-3 rounded-2xl bg-[#FDF6DA] border border-nanina-butter/60 px-4 py-3" data-testid="promo-banner">
      <Tag className="h-4 w-4 mt-0.5 text-nanina-green shrink-0" />
      <div>
        <p className="text-sm font-semibold text-nanina-green">{s.promo_title}</p>
        {s.promo_description && <p className="text-xs text-nanina-muted mt-0.5">{s.promo_description}</p>}
      </div>
    </div>
  ) : null;

export const ServiceExplorer = () => {
  const { site, activeId, selectService } = useSite();
  const active = site.categories.find((c) => c.id === activeId);
  const sched = site.settings.service_schedules || {};
  return (
    <section id="layanan" className="py-12 sm:py-16" data-testid="services-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-6">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">Layanan Nanina Care</p>
            <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Pilih layanan yang Anda butuhkan</h2>
          </div>
          <p className="text-xs sm:text-sm text-nanina-muted max-w-sm">Ketuk salah satu layanan untuk melihat highlight, tarif, dan dokumentasinya.</p>
        </div>
        <PromoBanner s={site.settings} />
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3" role="tablist" aria-label="Kategori layanan">
          {site.categories.map((c) => {
            const on = c.id === activeId;
            return (
              <button
                key={c.id}
                role="tab"
                aria-selected={on}
                onClick={() => selectService(c.id)}
                className={`relative text-left rounded-2xl border p-3 sm:p-4 min-h-[108px] sm:min-h-[128px] flex flex-col gap-3 transition-[transform,background-color,box-shadow] duration-200 ${on ? "bg-nanina-green text-white border-nanina-green shadow-[0_14px_28px_rgba(49,95,82,0.22)]" : "bg-white text-nanina-green border-nanina-line hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(35,75,67,0.08)]"}`}
                data-testid={`service-tab-${c.slug}`}
              >
                <span className={`grid place-items-center h-9 w-9 sm:h-11 sm:w-11 rounded-xl ${on ? "bg-white/15" : "bg-nanina-skysoft"}`}>
                  <ServiceIcon name={c.icon} className="h-5 w-5" />
                </span>
                <span className="text-[11px] sm:text-[13px] font-bold leading-snug">{c.name}</span>
                {c.identity && <span className={`text-[10px] -mt-2 ${on ? "text-white/75" : "text-nanina-muted"}`}>{c.identity}</span>}
                {["full", "temp_closed", "closed"].includes(sched[c.id]?.status) && (
                  <span className="self-start -mt-1 rounded-full bg-nanina-butter/70 text-nanina-green text-[9px] sm:text-[10px] font-semibold px-2 py-0.5" data-testid={`service-tab-status-${c.slug}`}>{AVAIL_LABEL[sched[c.id].status]}</span>
                )}
                <ChevronDown className={`absolute right-2.5 top-3 h-3.5 w-3.5 transition-transform ${on ? "rotate-180 text-white" : "text-[#98B8AC]"}`} />
              </button>
            );
          })}
        </div>
        {active && <ServiceDetail category={active} />}
      </div>
    </section>
  );
};
